import {
  CardComponent,
  AtlasCaption,
  AtlasBodyMain,
  TagMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'

interface TransferProgressCardProps {
  docNum: string
  warehouse?: string
  palletsLabel?: string
  productsLabel?: string
}

export const TransferProgressCard = (props: TransferProgressCardProps) => {
  const { docNum, warehouse, palletsLabel, productsLabel } = props

  return (
    <CardComponent $variant="highlight">
      <StackAtom $direction="column" $gap={8}>
        <AtlasCaption>Solicitud</AtlasCaption>

        <StackAtom $justify="space-between" $align="center">
          <AtlasBodyMain
            style={{
              fontWeight: 700,
              maxWidth: '100px',
              wordBreak: 'break-all'
            }}
          >
            {docNum}
          </AtlasBodyMain>

          <StackAtom $gap={8}>
            {warehouse && <TagMolecule text={warehouse} bgColor="#5C5C5C" />}
            {palletsLabel && (
              <TagMolecule
                text={palletsLabel}
                bgColor="#5C5C5C"
                icon={<Icon name="ic_pallet" size={18} color="white" />}
              />
            )}
            {productsLabel && (
              <TagMolecule
                text={productsLabel}
                bgColor="#5C5C5C"
                icon={<Icon name="ic_product" size={18} color="white" />}
              />
            )}
          </StackAtom>
        </StackAtom>
      </StackAtom>
    </CardComponent>
  )
}
